import { AlertCircle, Check, X } from 'lucide-react';
import type { PendingInvite } from '@danda/shared';

interface PendingInvitesBannerProps {
  invites: PendingInvite[];
  visible: boolean;
  onAccept: (inviteId: string) => void;
  onDecline: (inviteId: string) => void;
}

export function PendingInvitesBanner({
  invites,
  visible,
  onAccept,
  onDecline,
}: PendingInvitesBannerProps) {
  if (!visible || invites.length === 0) return null;
  return (
    <div className="bg-yellow-900/20 text-yellow-200 p-3 rounded-md mb-2 text-sm border border-yellow-800 space-y-2">
      {invites.map((invite) => (
        <div key={invite.id} className="flex items-center gap-2">
          <AlertCircle className="h-4 w-4 text-yellow-400 shrink-0" />
          <span className="flex-1 min-w-0">
            <span className="font-semibold">{invite.invitedBy}</span> invited you to join their
            party.
          </span>
          <button
            type="button"
            onClick={() => onAccept(invite.id)}
            className="shrink-0 inline-flex items-center gap-1 rounded-md bg-emerald-700 hover:bg-emerald-600 text-emerald-50 px-2.5 py-1 text-xs font-semibold"
            aria-label={`Accept party invite from ${invite.invitedBy}`}
          >
            <Check className="h-3.5 w-3.5" />
            Accept
          </button>
          <button
            type="button"
            onClick={() => onDecline(invite.id)}
            className="shrink-0 inline-flex items-center gap-1 rounded-md bg-zinc-700 hover:bg-zinc-600 text-zinc-100 px-2.5 py-1 text-xs font-semibold"
            aria-label={`Decline party invite from ${invite.invitedBy}`}
          >
            <X className="h-3.5 w-3.5" />
            Decline
          </button>
        </div>
      ))}
      <div className="text-xs text-yellow-300/80 pl-6">
        You can also ask Tavian to accept or decline for you.
      </div>
    </div>
  );
}
